import React from 'react';
import PropTypes from 'prop-types';

const NoImageComponent = ({ fileName, className, width="auto", height="auto", alt }) => {
  const getImageSrc = () => {
    if (!fileName) return null;
    
    try {
      return require(`../../../assets/img/${fileName}`);
    } catch (error) {
      console.warn(`Image not found: ${fileName}`);
      return null;
    }
  };

  const imageSrc = getImageSrc();

  const handleImageError = (e) => {
    console.warn(`Failed to load image: ${fileName}`);
    // Hide the image element
    e.target.style.display = 'none';
    // Show fallback
    if (e.target.nextSibling) {
      e.target.nextSibling.style.display = 'block';
    }
  };

  return (
    <div className="position-relative">
      {imageSrc && (
        <img loading="lazy"
          src={imageSrc} 
          className={className} 
          alt={alt} 
          width={width} 
          height={height}
          onError={handleImageError}
        />
      )}
    </div>
  );
};

NoImageComponent.propTypes = {
  fileName: PropTypes.string,
  className: PropTypes.string,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  alt: PropTypes.string.isRequired
};

export default NoImageComponent;
